import Api from '@/services/Api'

export default {
  get(id) {
    return Api().get('apps/' + id + '/customers')
  },

  getCustomer(appId, id) {
    return Api().get('apps/' + appId + '/customers/' + id)
  },

  add(appId, payload) {
    return Api().post('apps/' + appId + '/customers', payload)
  },

  update(appId, customerId, payload) {
    return Api().put('apps/' + appId + '/customers/' + customerId, payload)
  },

  delete(appId, customerId) {
    return Api().delete('apps/' + appId + '/customers/' + customerId)
  },

  getOrders(customerId) {
    return Api().get(`${customerId}/orders`)
  },

  search(customerId, search) {
    return Api().get(`${customerId}/orders/search`, {
      params: {
        search: search
      }
    })
  },

  getOrder(customerId, orderId) {
    return Api().get(`${customerId}/order/${orderId}`)
  },
  
  getUnpaidOrders(customerId) {
    return Api().get(`${customerId}/orders/unpaid`)
  },
  
  getInvoices(appId, customerId) {
    return Api().get(`apps/${appId}/customers/${customerId}/invoices`)
  },

  getInvoiceOrders(appId, customerId, invoiceId) {
    return Api().get(`apps/${appId}/customers/${customerId}/invoices/${invoiceId}/orders`)
  },
  getInvoiceProductOverview(appId, customerId, invoiceId) {
    return Api().get(`apps/${appId}/customers/${customerId}/invoices/${invoiceId}/csv`)
  },
  getInvoiceProductDetails(appId, customerId, invoiceId) {
    return Api().get(`apps/${appId}/customers/${customerId}/invoices/${invoiceId}/csv/details`)
  },
  
  generateInvoiceCSV(appId, customerId, invoiceId) {
    return Api().post(`apps/${appId}/customers/${customerId}/invoices/${invoiceId}/generate-csv`)
  },

  createInvoice(appId, customerId, payload) {
    return Api().post(`apps/${appId}/customers/${customerId}/invoices/create`, payload)
  },

  createERPInvoice(appId, customerId, payload) { 
    return Api().post(`apps/${appId}/customers/${customerId}/invoices/createERP`, payload)
  },

  getACDInvoices() {
    return Api().get('acd/invoices');
  },

  getACDInvoiceOrders(invoiceId) {
    return Api().get(`acd/invoices/${invoiceId}/orders`);
  },

  getACDInvoiceProductDetails(invoiceId) {
    return Api().get(`acd/invoices/${invoiceId}/csv/details`);
  },

  getACDInvoiceProductOverview(invoiceId) {
    return Api().get(`acd/invoices/${invoiceId}/csv`);
  },
  
  createACDERPInvoice(payload) {
    return Api().post(`acd/invoices/create/erp`, payload)
  },

  //Creation ACD
  getInvoicesForACD() {
    return Api().get('acd/invoices/unpaid');
  },

  createConsolidatedInvoice(payload) {
    return Api().post('acd/invoices/create', payload);
  },

  print(urls, printer) {
    return Api().post('print', {urls: urls, printer: printer})
  }
}